import { CssReset } from "@homebound/beam";
import { PropsWithChildren } from "react";
import { PostHogProviderWrapper } from "src/utils/PostHogProviderWrapper";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

/**
 * SHARED — query-param adapter, global CSS reset, and PostHog wrapper.
 *
 * Data router: `AppShell` / `GuestShell` / `PdfLayout` → `RouteEnvironmentProviders`
 */
export function RouteEnvironmentProviders(props: PropsWithChildren) {
  return (
    <QueryParamProvider adapter={ReactRouter6Adapter}>
      <CssReset />
      <PostHogProviderWrapper>{props.children}</PostHogProviderWrapper>
    </QueryParamProvider>
  );
}
